import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const scaleFontSize = (value, defaultSize = 18) => {
    if (value.length < 13) return `font-size: ${defaultSize}px;`;
    const size = defaultSize - (value.length - 12 + 1);

    return `font-size: ${size >= 12 ? size : 12}px;`;
};

const TextInputTop = styled.input`
    width: 100%;
    height: 25px;
    margin: 0;
    padding: 0 2px;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
    border: none;
    background-color: #005caa;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    color: #fff;
    transition: all 0.2s ease;

    :focus {
        outline: none;
        background-color: #013663;
    }

    ::-webkit-input-placeholder {
        color: #fff;
    }

    ::-moz-placeholder {
        color: #fff;
    }

    :-ms-input-placeholder {
        color: #fff;
    }

    :-moz-placeholder {
        color: #fff;
    }

    ${({ typeStyle }) =>
        typeStyle === 'bottom' &&
        `
        background-color: rgba(0, 0, 0, 0.5);

        :focus {
            background-color: #000;
        }
    `};

    ${({ value }) => scaleFontSize(value, 18)};
    ${({ lineupType, value }) =>
        lineupType === 'grid' && `height: 30px; ${scaleFontSize(value, 18)} line-height: 30px;`};
    ${({ large, value }) => large && `height: 36px; ${scaleFontSize(value, 22)} line-height: 36px;`};
    ${({ typeStyle, large, value }) =>
        typeStyle === 'bottom' && large && `height: 30px; ${scaleFontSize(value, 22)} line-height: 30px;`};
`;

class TextInput extends Component {
    state = {
        value: this.props.text || ''
    };

    componentDidMount() {
        this.props.action(this.props.id, this.state.value);
    }

    componentWillReceiveProps({ text: nextText }) {
        if (nextText !== this.props.text) {
            this.setState({
                value: nextText
            });
        }
    }

    changeTextHandler = event => {
        this.setState({
            value: event.target.value
        });
    };

    blurTextHandler = event => {
        this.props.action(this.props.id, event.target.value);
    };

    render() {
        return (
            <TextInputTop
                type="text"
                typeStyle={this.props.type}
                lineupType={this.props.lineupType}
                large={this.props.large}
                placeholder="Edit text..."
                value={this.state.value}
                onChange={this.changeTextHandler}
                onBlur={this.blurTextHandler}
            />
        );
    }
}

TextInput.propTypes = {
    id: PropTypes.number.isRequired,
    text: PropTypes.string,
    large: PropTypes.bool,
    type: PropTypes.string,
    lineupType: PropTypes.string,
    action: PropTypes.func.isRequired
};

export default TextInput;



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/TextInput.js
 **/